import vue from "vue";
import { post, fetch, Del, put } from "@/ask/axios";
import router from "@/router/index";
import { setCookie, getCookie } from "@/ask/cookiejs";

const state = () => ({
  token:
    getCookie("X-BY-EnTOKEN") === "null" ? null : getCookie("X-BY-EnTOKEN"),
  userIP: null
});

const mutations = {
  ENTER_LOGIN(state) {},
  SET_USERIP(state, userIP) {
    state.userIP = userIP;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  }
};

const actions = {
  login({ commit }, params) {
    return new Promise((resolve, reject) => {
      const url =
        vue.prototype.$api02 + "/api/EbayCustomer/CustomerInfo/Login_En";
      post(url, params).then(res => {
        resolve(res);
        setCookie("X-BY-EnTOKEN", res.Results.Token);
        setCookie("IMEn-TOKEN", res.Results.IMToken);
        sensors.login(res.Results.UserID);
      });
    });
  },
  getIP({ commit }, params) {
    return new Promise((resolve, reject) => {
      vue.prototype
        .$jsonp("https://api.ipify.org?format=jsonp")
        .then(res => {
          return res;
        })
        .then(res => {
          post(vue.prototype.$api04 + "/Air/api/GetCountry/GetCountry", {
            ip: res.ip
          }).then(({Results}) => {
            commit("SET_USERIP", Results.GetCountry);
            resolve({...Results,ip:res.ip});
            
          });
        });
    });
  }
};

export default {
  state,
  mutations,
  actions,
  namespaced: true
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js